import { render, staticRenderFns } from "./WorkspacesMenu.vue?vue&type=template&id=3bf2da0a&"
import script from "./WorkspacesMenu.vue?vue&type=script&lang=js&"
export * from "./WorkspacesMenu.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacesMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkspacesMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/WorkspacesMenu.vue
// module id = 1656
// module chunks = 1